import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

const staleReleaseRecoveryKey = 'onzoe:stale-release-recovery'

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()

  try {
    const now = Date.now()
    const currentUrl = window.location.href
    const previousAttempt = JSON.parse(window.sessionStorage.getItem(staleReleaseRecoveryKey) || 'null') as {
      url?: string
      attemptedAt?: number
    } | null

    if (
      previousAttempt?.url === currentUrl &&
      typeof previousAttempt.attemptedAt === 'number' &&
      now - previousAttempt.attemptedAt < 60_000
    ) {
      return
    }

    window.sessionStorage.setItem(staleReleaseRecoveryKey, JSON.stringify({ url: currentUrl, attemptedAt: now }))
  } catch {
    // Storage can be unavailable in hardened browser modes. Reloading still
    // gives the browser one chance to obtain the current release document.
  }

  window.location.reload()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
